export { cn } from 'cn'
export { tv } from 'tailwind-variants'
export type { VariantProps } from 'tailwind-variants'

export const focusRingClassName =
  'outline-solid outline-offset-2 outline-0 focus-visible:outline-2 outline-tremor-brand-subtle'
